import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminChainsaws from "@/pages/admin/AdminChainsaws";

export const Route = createFileRoute("/admin/chainsaws/")({
  component: () => (
    <ProtectedRoute>
      <AdminChainsaws />
    </ProtectedRoute>
  ),
});
